import React from 'react';
import { Translate } from 'react-localize-redux';
import { arrayOf, func } from 'prop-types';
import { withLang, langType } from '../../../i18n';
import { surveySchemaMetadataType } from '../../../constants/types';
import SchemaPartDragDrop from '../../Editor/SurveySchemaEditor/SchemaPartDragDrop';

const SelectedExtraSurveyPart = ({
  lang,
  schemaParts,
  onRemoveSchemaPart,
  onUpdateSchemaParts,
  translate: t
}) => (
  <div>
    {<h3><Translate id="extraSurveyParts.selectedSchemaPartTitle" /></h3>}
    {schemaParts.length > 0
      ? (
        <SchemaPartDragDrop
          currentLanguage={lang}
          schemaParts={schemaParts}
          onRemoveSchemaPart={onRemoveSchemaPart}
          updateSchemaParts={onUpdateSchemaParts}
          lockedFromEditing={false}
          onUpdateSchemaPartVersion={() => {}}
        />
      )
      : <>{t('extraSurveyParts.noSelectedSchemaPart')}</>}
  </div>
);

SelectedExtraSurveyPart.propTypes = {
  schemaParts: arrayOf(surveySchemaMetadataType).isRequired,
  onRemoveSchemaPart: func.isRequired,
  onUpdateSchemaParts: func,
  ...langType
};

SelectedExtraSurveyPart.defaultProps = {
  onUpdateSchemaParts: () => {}
};

export default withLang(
  SelectedExtraSurveyPart
);
